<template>
  <div class="card shadow-bg">
    <div class="card-header">
      <h3 class="mb-0">{{title || "Date Range"}}</h3>
    </div>
    <div class="card-body">
      <base-input prepend-icon="fas fa-calendar-alt">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          @on-change="$emit('change', $event)"
          v-model="dateFiltersLocal"
          :config="{ allowInput: true, mode: 'range' }"
          class="form-control datepicker"
        >
        </flat-picker>
      </base-input>
    </div>
  </div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'PeriodSelection',
  components: {
    flatPicker
  },
  props: {
    dateFilters: Array,
    title: String
  },
  data() {
    return {
      dateFiltersLocal: []
    }
  },
  async created() {
    this.dateFiltersLocal = this.dateFilters
  }
}
</script>

<style scoped></style>
